import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { VideoPage } from '../pages/video/video';
import { Slide1Page } from '../pages/slide1/slide1';
import { Slide2Page } from '../pages/slide2/slide2';
import { Slide3Page } from '../pages/slide3/slide3';
import { Slide4Page } from '../pages/slide4/slide4';
import { Slide5Page } from '../pages/slide5/slide5';
import { Slide6Page } from '../pages/slide6/slide6';
import { RecommendationPage } from '../pages/recommendation/recommendation';
import { AdminSettingsPage } from '../pages/admin-settings/admin-settings';
import { GeneralErrorPage } from '../pages/error/general';
import { SMSTermsPage } from '../pages/sms-terms/sms-terms';

const appRoutes: Routes = [
  { path: '', component: VideoPage },
  { path: 'home', component: VideoPage },
  { path: 'visual-challenges', component: Slide1Page },
  { path: 'age', component: Slide2Page },
  { path: 'environment', component: Slide3Page },
  { path: 'devices', component: Slide4Page },
  { path: 'issues-experienced', component: Slide5Page },
  { path: 'visual-behaviour', component: Slide6Page },
  { path: 'recommendation', component: RecommendationPage },
  { path: 'admin-settings', component: AdminSettingsPage },
  { path: 'SMSTerms', component: SMSTermsPage },
  { path: 'error', component: GeneralErrorPage },
];
@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts